import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
    Close,
    OpenInFull,
} from "@mui/icons-material";
import {
    MediaMuteButton,
    MediaPlayButton,
    MediaSeekBackwardButton,
    MediaSeekForwardButton,
    MediaTimeDisplay,
    MediaTimeRange,
} from "media-chrome/react";
import ToolsLayer from "./ToolsLayer";

const MinimizedOverlay = ({
    watchType,
    isMaximized,
    handleMaximize,
    handleClosePlayer,
    setIsMuted,
}) => {
    return (
        <ToolsLayer watchType={watchType} isMaximized={isMaximized}>
            {watchType === "watch" && (
                <Tooltip title={"Mettre en plein écran"} placement={"top"}>
                    <IconButton
                        onClick={handleMaximize}
                        sx={{
                            color: "white",
                            position: "absolute",
                            top: "10px",
                            left: "10px",
                            backgroundColor: (theme) => theme.palette.videoColors.button,
                            "&:hover": {
                                backgroundColor: (theme) =>
                                    theme.palette.videoColors.buttonHover,
                            },
                        }}
                    >
                        <OpenInFull />
                    </IconButton>
                </Tooltip>
            )}
            <IconButton
                onClick={handleClosePlayer}
                sx={{
                    color: "white",
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: (theme) => theme.palette.videoColors.button,
                    "&:hover": {
                        backgroundColor: (theme) => theme.palette.videoColors.buttonHover,
                    },
                }}
            >
                <Close />
            </IconButton>

            <Box
                sx={{
                    position: "absolute",
                    top: watchType === "watch" ? "50%" : "37%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                }}
            >
                <Tooltip title={"Reculer de 5 secondes"} placement="top">
                    <MediaSeekBackwardButton
                        notooltip
                        seekOffset={5}
                        style={{
                            borderRadius: "50%",
                        }}
                    />
                </Tooltip>
                <MediaPlayButton
                    notooltip
                    style={{
                        transform: "scale(1.5)",
                        borderRadius: "50%",
                    }}
                />
                <Tooltip title={"Avancer de 5 secondes"} placement="top">
                    <MediaSeekForwardButton
                        notooltip
                        seekOffset={5}
                        style={{
                            borderRadius: "50%",
                        }}
                    />
                </Tooltip>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    position: "absolute",
                    bottom: "0",
                    width: "100%",
                    left: "0",
                }}
            >
                <Tooltip title={"Couper / activer le son"} placement="top">
                    <MediaMuteButton
                        notooltip
                        onClick={() => {
                            setIsMuted((prevMuted) => !prevMuted);
                        }}
                    />
                </Tooltip>
                <MediaTimeRange
                    style={{
                        width: "100%",
                    }}
                />
                <MediaTimeDisplay showDuration />
            </Box>
        </ToolsLayer>
    );
};

export default MinimizedOverlay;
